import type { ConsoleIndexEntry } from '@aithora/shared';
import { takeWindowData } from './takeWindowData';

// The console's help index (one entry per page: what it is for, its badges, what is
// real today). SOURCE: the Sep 16 copy the design ships as a script that sets
// window.CONSOLE_INDEX. The new copy arrives with the design package; swapping it in is
// this one import line.
import '../../../../design-preview/console-index-data.js';

export const CONSOLE_INDEX: readonly ConsoleIndexEntry[] = takeWindowData<ConsoleIndexEntry[]>('CONSOLE_INDEX', []);
